export const deviceSize = Object.freeze({
  mobile: "500px",
});
